export default __webpack_public_path__ + "static/media/Raider's Gauntlets of the Khan.e2bd0daa.jpg";